module.exports = "/dist/assets/images/plus-white.svg";